import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { CardOccasion, OCCASION_CATEGORIES } from '../../types/cards';
import { Contact } from '../../types';

interface OccasionSelectorModalProps {
  onSelect: (occasion: CardOccasion) => void;
  onClose: () => void;
  defaultOccasion?: CardOccasion;
  contact?: Contact;
  isOpen: boolean;
}

export function OccasionSelectorModal({
  onSelect,
  onClose,
  defaultOccasion,
  contact,
  isOpen
}: OccasionSelectorModalProps) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-2xl font-medium leading-6 text-gray-900 mb-4"
                >
                  Select Card Occasion
                </Dialog.Title>

                <div className="mt-4 space-y-6">
                  {Object.entries(OCCASION_CATEGORIES).map(([category, occasions]) => (
                    <div key={category}>
                      <h4 className="text-lg font-medium text-gray-700 mb-3">{category}</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        {occasions.map((occasion) => (
                          <button
                            key={occasion.id}
                            onClick={() => onSelect(occasion.id as CardOccasion)}
                            className={`p-4 rounded-lg border transition-all ${
                              defaultOccasion === occasion.id
                                ? 'border-blue-500 bg-blue-50'
                                : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                            }`}
                          >
                            <div className="text-2xl mb-2">{occasion.icon}</div>
                            <div className="font-medium text-gray-900">{occasion.label}</div>
                            <div className="text-sm text-gray-500">{occasion.description}</div>
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
} 